import client from './client';

const eqpUrl = '/api/v1/eqp';

// ============================= (B) 공구/매거진 FOCAS 읽기 전용 진단 =============================
// 장비 상세 [공구 정보 진단] - 서버가 /config에 작업을 실어 보내고 에이전트가 1회 보고(discovery와 같은 패턴).

export const createToolDiag = (eqpUuid, body) =>
  client.post(`${eqpUrl}/${eqpUuid}/tool-diag`, body || {});

export const getLatestToolDiag = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/tool-diag/latest`);

export const getToolDiagHistory = (eqpUuid, limit = 5) =>
  client.get(`${eqpUrl}/${eqpUuid}/tool-diag/history`, { params: { limit } });

export const extractInfo = (res) => res?.data?.info ?? null;
export const extractList = (res) => res?.data?.list ?? [];
